/**
 * CTG homepage: when the URL carries ?ctg-cause=<handle>, rewrite the page title
 * and Open Graph / description meta tags for that cause. If the cause's canonical
 * URL belongs to the other brand, use the other brand's metadata instead.
 *
 * Reads the JSON emitted by snippets/cusa-meta-tags.liquid into #cause-data.
 * Moved out of that snippet (inline) so it is cached as a versioned asset.
 */
document.addEventListener('DOMContentLoaded', function () {
	const causeDataScript = document.getElementById('cause-data');
	if (!causeDataScript) return;

	let data;
	try {
		data = JSON.parse(causeDataScript.textContent);
	} catch (error) {
		return;
	}
	const dev = Boolean(data.dev);

	// Get the `ctg-cause` URL parameter
	const causeHandle = new URLSearchParams(window.location.search).get('ctg-cause');
	if (!causeHandle) {
		if (dev) console.log('ctg-cause not detected in URL.');
		return;
	}

	// Find matching cause by handle
	const cause = (data.causes || []).find((c) => c.handle === causeHandle);
	if (!cause) {
		if (dev) console.log('Cause not found for handle:', causeHandle);
		return;
	}

	const setMeta = (selector, value) => {
		const el = document.querySelector(selector);
		if (el) el.setAttribute('content', value);
	};
	const apply = (meta) => {
		const title = document.querySelector('title');
		if (title) title.innerText = meta.title;
		setMeta("meta[name='description']", meta.description);
		setMeta("meta[property='og:title']", meta.title);
		setMeta("meta[property='og:image']", meta.image);
		setMeta("meta[property='og:image:secure_url']", meta.image);
		setMeta("meta[property='og:image:width']", meta.image_width);
		setMeta("meta[property='og:image:height']", meta.image_height);
		setMeta("meta[property='og:description']", meta.description);
	};

	// Check ARS canonical URL boolean against the current hostname
	const canonicalIsArs = cause.canonical_is_ars === 'true';
	const onArs = window.location.hostname.includes('theanimalrescuesite');

	if ((onArs && !canonicalIsArs) || (!onArs && canonicalIsArs)) {
		// Canonical lives on the other brand: use the other brand's metadata
		apply(data.alt_brand || {});
	} else {
		// Default: use the cause's own metadata
		apply({
			title: cause.og_meta_title,
			description: cause.og_meta_description,
			image: 'https:' + cause.og_meta_image,
			image_width: cause.og_meta_image_width,
			image_height: cause.og_meta_image_height
		});
	}
});
